
<template>
  <div>
    <van-nav-bar
      title="选择楼层区域"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <div class="p-2">
      <div class="flex space-x-1">
        <van-button
          class="shadow-md"
          round
          plain
          v-for="(sday) in days"
          :key="sday"
          :class="{ selected: sday === day }"
          @click="selectDay(sday)"
          ><span class="whitespace-nowrap"
            >{{ sday }}</span
          ></van-button
        >
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">分馆</span>
        <div
          class="
            mt-1
            grid grid-cols-3
            justify-evenly
            items-center
            gap-1
            middle-text
          "
        >
          <div
            v-for="lib in libraries"
            :key="lib.id"
            class="
              whitespace-nowrap
              leading-5
              rounded
              text-center
              shadow-md
              bg-white
            "
            :class="{ selected: lib.id === library.id, flex: lib.isFull, 'justify-between':lib.isFull }"
            @click="selectLibrary(lib)"
          >
            <span>{{ lib.name }}</span>
            <span style="margin-top: -3px" v-if="lib.isFull">
              <van-tag
                plain
                type="danger"
                >约满</van-tag
              >
            </span>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">楼层</span>
        <div class="mt-1 grid grid-cols-3 justify-evenly gap-1">
          <div
            v-for="fl in floors"
            :key="fl.id"
            class="
              leading-1
              whitespace-nowrap
              p-1
              small-text
              rounded
              shadow-md
              bg-white
              flex
              justify-between
            "
            :class="{ selected: fl.id === floor.id }"
            @click="selectFloor(fl)"
          >
            <span>{{ fl.name }}</span>
            <span style="margin-top: -3px">
              <van-tag
                plain
                type="success"
                v-if="fl.TotalCount > fl.UnavailableSpace"
                >空余{{ fl.TotalCount - fl.UnavailableSpace }}</van-tag
              >
              <van-tag plain type="danger" v-else>约满</van-tag>
            </span>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">区域</span>
        <van-empty v-if="areas.length == 0" description="无可用区域" />
        <div
          v-else
          class="mt-1 mb-4 grid grid-cols-2 justify-evenly items-center gap-1"
        >
          <div
            v-for="ar in areas"
            :key="ar.id"
            class="leading-1 p-1 rounded text-center shadow-md bg-white"
            :class="{ selected: ar.id === area.id }"
            @click="selectArea(ar)"
          >
            <!-- <div
              class="
                grid grid-cols-2
                justify-evenly
                small-text
                whitespace-normal
              "
            >
              <div class="place-self-start">{{ ar.name }}</div>
              <div class="place-self-end">
                <van-tag
                  plain
                  type="success"
                  v-if="ar.TotalCount > ar.UnavailableSpace"
                  >空余{{ ar.TotalCount - ar.UnavailableSpace }}</van-tag
                >
                <van-tag plain type="danger" v-else>约满</van-tag>
              </div>
            </div> -->
            <div
              class="
                flex flex-col
                small-text
              "
            >
              <div class="text-left">{{ ar.name }}</div>
              <div class="whitespace-nowrap text-right">
                <van-tag
                  plain
                  type="success"
                  v-if="ar.TotalCount > ar.UnavailableSpace"
                  >空余{{ ar.TotalCount - ar.UnavailableSpace }}</van-tag
                >
                <van-tag plain type="danger" v-else>约满</van-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-row class="fixed left-0 bottom-0 w-full bg-white small-text">
      <van-col span="6">
        <div class="text-center" @click="refresh">
          <van-icon name="replay" />
          <span class="block">刷新</span>
        </div>
      </van-col>
      <van-col span="18">
        <van-button
          :disabled="area.TotalCount == area.UnavailableSpace"
          block
          size="large"
          color="#49cfd4"
          @click="goBooking"
          >确认选择</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import _ from "lodash";
import { myStorage } from "../utils/util";
import { getAreas, getOpenDays, getMyBookings, getSysConfig } from "@/service/home";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {Toast} from "vant";
export default {
  name: "chooseSpace",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      allData: {},
      libraries: [],
      sysconfig: {},
      floors: [],
      areas: [],
      days: [],
      day: dayjs().format("YYYY-MM-DD"),
      library: {},
      floor: {},
      area: {},
      latestFound: false,
    });
    onMounted(async () => {
      state.sysconfig = await getSysConfig();
      await getLatestBooking();
      await init();
    });

    watch(
      () => state.library,
      (newValue) => {
        state.floors = _.filter(state.allData, {
          parentId: newValue.id,
          isValid: 1,
        });
        let latestFloor = myStorage.get("latestFloor");
        state.floor =
          state.latestFound &&
          latestFloor &&
          _.findIndex(state.floors, ["id", latestFloor.id]) > -1
            ? latestFloor
            : state.floors[0];
        myStorage.set("library", newValue);
      }
    );
    watch(
      () => state.floor,
      (newValue) => {
        state.areas = _.filter(state.allData, {
          parentId: newValue.id,
          isValid: 1,
        });
        let latestArea = myStorage.get("latestArea");
        state.area =
          state.latestFound &&
          latestArea &&
          _.findIndex(state.areas, ["id", latestArea.id]) > -1
            ? _.find(state.areas, ["id", latestArea.id])
            : state.areas[0];
        myStorage.set("floor", newValue);
        myStorage.set("area", state.area);
      }
    );
    const getLatestBooking = async () => {
      try {
        const {
          data,msg
        } = await getMyBookings({
          access_token: user.access_token,
          userid: user.userid,
          count:1
        });
        if (data == null) {
          throw new Error(msg);
        }
        let latestSeatBooking = _.filter(data.list, { isSingle: 1 })[0];
        if (latestSeatBooking) {
          myStorage.set(
            "latestLib",
            latestSeatBooking.spaceDetailInfo.areaInfo.parentAreaInfo[0]
          );
          myStorage.set(
            "latestFloor",
            latestSeatBooking.spaceDetailInfo.areaInfo.parentAreaInfo[1]
          );
          myStorage.set(
            "latestArea",
            latestSeatBooking.spaceDetailInfo.areaInfo.parentAreaInfo[2]
          );
        }
      } catch (error) {
        Toast({
            message: '系统繁忙，请稍后',
            forbidClick: true,
            overlay: true,
        });
      }
    };
    const init = async () => {
      try {
        const {
          data
        } = await getAreas(state.day==dayjs().format("YYYY-MM-DD")?undefined:{ date: state.day});
        if (data == null || data.list == null) {
          throw new Error("当日暂停使用");
        }
        const disabledIDs  = state.sysconfig.SYS_WEB_SCHOOL_DISABLE?state.sysconfig.SYS_WEB_SCHOOL_DISABLE.split(",").map(id=>parseInt(id)):[];
        state.allData = data.list.seatinfo.filter(it=>!disabledIDs.includes(it.id));
        state.libraries.length = 0;
        myStorage.set("allSeats", state.allData);
        let allLibs = data.list.seatinfo.filter((lib) => !disabledIDs.includes(lib.id) && lib.parentId === 0 && lib.isValid ===1);
        _.each(allLibs, (lib) => {
          let floors = _.filter(data.list.seatinfo, (item) => !disabledIDs.includes(item.id) && item.parentId === lib.id);
          let areas = [];
          _.each(floors, (fl)=> {
            let subAreas = _.filter(data.list.seatinfo, (item)=>!disabledIDs.includes(item.id) && item.parentId === fl.id);
            areas = _.concat(areas, subAreas);
          });
          if (areas.length>0) {
            state.libraries.push(lib);
          }
          if (
            _.every(floors, (item) => item.TotalCount == item.UnavailableSpace)
          ) {
            lib.isFull = true;
          }
        });
        let latestLib = myStorage.get("latestLib");
        [state.latestFound, state.library] =
          latestLib && _.findIndex(state.libraries, ["id", latestLib.id]) > -1
            ? [true, latestLib]
            : [false, state.libraries[0] || state.library];
        const { data:opendays } = await getOpenDays(state.library.id);
        if (opendays==null) {
          throw new Error("当日暂停使用");
        }
        state.days = opendays.list.map((item) => item.day.date.slice(0, 10));
        state.day = state.day || state.days[0];
        myStorage.set("day", state.day);
      } catch (error) {
        Toast.fail(error.message);
      }
    };
    const refresh = () => {
      init();
    };

    const goBack = () => router.go(-1);
    const selectDay = (day) => {
      if (state.day != day) {
        state.day = day;
        init();
      }
      
    };
    const selectLibrary = (lib) => {
      state.library = lib;
    };
    const selectFloor = (fl) => {
      state.floor = fl;
    };
    const selectArea = (area) => {
      state.area = area;
      myStorage.set("area", area);
    };
    const goBooking = () => {
      router.push("/bookSeat");
    };
    const goHome = () => router.push("/index");
    return {
      goBack,
      selectDay,
      selectLibrary,
      selectFloor,
      selectArea,
      goBooking,
      refresh,
      goHome,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
</style>
